import React, { useEffect ,useState} from 'react';
import get from 'lodash/get';
import * as StyledComponents from '../StyledComponents';
import { PrimaryButton, IconSchedule, DatePicker, Checkbox, BUTTON_SIZES  } from 'cdk-radial';
import { useUnifyAdminStore } from '../../AdminStore';
import { TimeField } from '../Elements/TimeField';
import './notification.css';
import {
  useGetAllApplications,
  useGetAllWorkflows,
  useUserProfile
} from '../../../../hooks/queries';
import { MultiSelectDropdownMenu } from '../Elements/MultiSelectDropdownMenu';
import find from 'lodash/find';
import {  createOutageModel,
  updateOutageModel, translationModel } from '../Store/modelTransformation';
import styled from 'styled-components';
import { useTheme } from 'styled-components';
import {useCreateQuery,useUpdateQuery,useTranslator} from '../Store/useOutageNotificationQuery';
import CustomEditor from './CustomEditor';
import { getLocalizationValues } from '../../utils';
import { OutageCustomMultiTargetEditor } from './OutageCustomMultiTargetEditor';
import {OutageBrowseOrDragBulkUpload} from './OutageBrowseOrDragBulkUpload';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface TabItem {
  id: string;
  panelId: string;
  renderPanel: any;
  renderTab: any;
}

type Positions = {
  top: string;
  bottom: string;
  left: string;
  right: string;
};

type ActionButtonsContainer = {
  children: React.ReactNode;
  position?: string;
  positionProps?: Partial<Positions>;
  background?: string;
  zIndex?: string
};

const ActionButtonContainer = ({
  children,
  position,
  positionProps,
  background,
  zIndex
}: ActionButtonsContainer): JSX.Element => {
  return (
    <StyledComponents.StyledActionButtonContainer
      positionProps={positionProps}
      position={position}
      background={background}
      zIndex={zIndex}
    >
      {children}
    </StyledComponents.StyledActionButtonContainer>
  );
};

function validateURL(url: string) {
  if (
    //eslint-disable-next-line
    /^(http[s]?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/g.test(
      url
    )
  ) {
    return true;
  } else {
    return false;
  }
}

export const StyledWrapperDatePicker = styled.div<{
  maxWidth: string;
  dayPickerLeft: string;
}>`
  max-width: ${(props) => props.maxWidth || '150px'};
  .DayPicker {
    left: ${(props) => props.dayPickerLeft || 'unset'};
    bottom: 0;
    margin-bottom: 55px;
    top: auto;
    z-index:1000;
  }
`;

const applicationToOptions = (data: any) => {
  if (data && data[0]) {
    const applications = data[0];
    if (applications) {
      const filteredApps = applications.filter(
        (app: any) =>
          app.isActive === true &&
          app.name !== 'Fortellis Marketplace Operations' &&
          app.name !== 'CDK University' &&
          app.name !== 'Customer Care' &&
          app.name !== 'Unify Administration' &&
          app.name !== 'CDK Resource Center'
      );
      let options = filteredApps.map((application: any) => {
        return {
          id: application.appId,
          label: application.name,
          value: application.appId,
        };
      });
      return options;
    }
  }
};

interface Option {
  id: string;
  label: string;
  value: string;
}

const filterWorkflowOptions = (applications: any, workflowsData: any) => {
  let filtered = [] as Option[];
  if (workflowsData) {
    const workflows = workflowsData[0];
    if (workflows) {
      workflows.forEach((workflow: any) => {
        if (
          workflow.applications &&
          workflow.applications[0] &&
          workflow.applications[0].appId &&
          workflow.isActive === true
        ) {
          const applId = workflow.applications[0].appId;
          const found = find(applications, (app: any) => app.id === applId);
          if (found) {
            filtered.push({
              id: workflow.workflowId,
              label: workflow.name,
              value: workflow.workflowId,
            });
          }
        }
      });
    }
  }
  return filtered;
};

export const OutageSideSheetDetails = (): JSX.Element => {
  const { t } = useTranslation();
  const { darkMode } = useTheme();

  const { data: userInfo } = useUserProfile();

  const sideSheetData = useUnifyAdminStore(
    (state) => state.productOutageSideSheetData
  );
  const archiveSwitch = useUnifyAdminStore((state) => state.productOutageArchiveSwitch);

    const showFrenchTranslation = useUnifyAdminStore((state) => state.showProductFrenchNotificationContent)
    const setShowFrenchTranslation = useUnifyAdminStore((state) => state.setShowProductFrenchNotificationContent)
    const showCanadaEnglishTranslation = useUnifyAdminStore((state) => state.showProductCanadaEnglishNotificationContent)
    const setShowCanadaEnglishTranslation = useUnifyAdminStore((state) => state.setShowProductCanadaEnglishNotificationContent)

  const showStartDateValidation = useUnifyAdminStore((state) => state.showStartDateValidation);
  const setShowStartDateValidation = useUnifyAdminStore((state) => state.setShowStartDateValidation);
  const showEndDateValidation = useUnifyAdminStore((state) => state.showEndDateValidation);
  const setShowEndDateValidation = useUnifyAdminStore((state) => state.setShowEndDateValidation);

  const {mutation:createMutation} = useCreateQuery({
    onSuccess: () => {
      setProductOutageShowToastState(t('productAlerts.toastCreateSuccess', { title: getLocalizationValues(userInfo, sideSheetData).title }), 'Success');
      closeSideSheet()
    },
    onError: () => {
      setProductOutageShowToastState(t('productAlerts.toastCreateError'), 'Error');
      closeSideSheet()
    }
  });

  const {mutation:updateMutation} = useUpdateQuery({
    onSuccess: () => {
      setProductOutageShowToastState(t('productAlerts.toastUpdateSuccess', { title: getLocalizationValues(userInfo, sideSheetData).title }), 'Success');
      closeSideSheet()
    },
    onError: () => {
      setProductOutageShowToastState(t('productAlerts.toastUpdateError'), 'Error');
      closeSideSheet()
    },
  });

  const { mutation: translateMutation } = useTranslator();

  const setWorkflowSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setAdminSideSheetCollapse
  );
  const setApplicationSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setWorkflowSideSheetCollapse
  );
  const setProductOutageSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setProductOutageSideSheetCollapse
  );

  const resetOutageNotifcationSideSheetState = useUnifyAdminStore(
    (state) => state.resetOutageNotifcationSideSheetState
  );

  const { data: applications } = useGetAllApplications();
  const { data: workflows } = useGetAllWorkflows();

  const outagePermission = useUnifyAdminStore(
    (state) => state.permissions
  );
  const applicationOptions = applicationToOptions(applications);
  const workflowOptions = filterWorkflowOptions(
    get(sideSheetData, 'targetApplications', []),
    workflows
  );

  const updateProductOutageSideSheetData = useUnifyAdminStore(
    (state) => state.updateProductOutageSideSheetData
  );
  const setProductOutageShowToastState = useUnifyAdminStore(
    (state) => state.setProductOutageShowToastState
  );
  const setIsValidationState = useUnifyAdminStore(
    (state) => state.setIsValidationState
  );

  const [status,setStatus] = useState('open');

  useEffect(()=>{
    if(sideSheetData.caseId &&
        sideSheetData.endDate !=null){
      setStatus('close');
    }
  },[sideSheetData]);

  const onApplicationSelect = (applications: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'targetApplications',
      value: applications,
    });
    const workflowOptions = filterWorkflowOptions(applications, workflows);

    //For removing selected workflows when their application deselect
    const selectedWorkflows = { ...sideSheetData.targetWorkflows };
    const updatedSelectedWorkflows = Object.values(selectedWorkflows).filter(
      (selectedWorkflow: any) =>
        workflowOptions.some(
          (workflowOption: any) =>
            workflowOption.id === selectedWorkflow.id
        )
    );
    updateProductOutageSideSheetData({
      fieldName: 'targetWorkflows',
      value: updatedSelectedWorkflows,
    });
  };
  const onWorkflowSelect = (applications: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'targetWorkflows',
      value: applications,
    });
  };
  const onStartDateChange = (startDate: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'startDate',
      value: startDate,
    });
  };
  const onEndDateChange = (endDate: any) => {
    updateProductOutageSideSheetData({ fieldName: 'endDate', value: endDate });
  };
  const onStartTimeChange = (startTime: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'startTime',
      value: startTime,
    });
  };
  const onEndTimeChange = (endTime: any) => {
    updateProductOutageSideSheetData({ fieldName: 'endTime', value: endTime });
  };
  const onCreatedTimeChange = (createdTime: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'createdTime',
      value: createdTime,
    });
  };
  const onCreatedDateChange = (createdDate: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'createdDate',
      value: createdDate,
    });
  };
  const onCaseIdChange = (e: any) => {
    updateProductOutageSideSheetData({
      fieldName: 'caseId',
      value: e.target.value,
    });
  };
  const descriptionBodyLocale = get(sideSheetData, 'bodyLocale');
    const titleLocale = get(sideSheetData, 'titleLocale');
    const subjectLocale = get(sideSheetData, 'subjectLocale');
    const linkToLearnMoreLocale = get(sideSheetData, 'linkToLearnMoreLocale');
  
    const onShortDescChange = (key: any = "enUS") => {
  
      const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");
  
      const inputEleVal = key.target.value;
  
      if (targetName === "enUS") {
        updateProductOutageSideSheetData({
          fieldName: 'subject',
          value: inputEleVal
        });
      } else {
  
        updateProductOutageSideSheetData({
          fieldName: 'subjectLocale',
          value: { enCA: (targetName === "enCA") ? inputEleVal : subjectLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : subjectLocale?.frCA }
        });
      }
    };
  
    const onTitleChange = (key: any = "enUS") => {
  
      const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");
  
      const inputEleVal = key.target.value;
  
      if (targetName === "enUS") {
        updateProductOutageSideSheetData({
          fieldName: 'title',
          value: inputEleVal
        });
      } else {
  
        updateProductOutageSideSheetData({
          fieldName: 'titleLocale',
          value: { enCA: (targetName === "enCA") ? inputEleVal : titleLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : titleLocale?.frCA }
        });
      }
    };
  
    const onLongDescChangeenUS = (e: any) => {
      updateProductOutageSideSheetData({
        fieldName: 'body',
        value: e.target.value,
    });
  };
  
    const onLongDescChangefrCA = (e: any) => {
      updateProductOutageSideSheetData({
        fieldName: 'bodyLocale',
        value: {frCA: e.target.value, enCA: descriptionBodyLocale?.enCA},
      });
    };
  
    const onLongDescChangeenCA= (e: any) => {
      updateProductOutageSideSheetData({
        fieldName: 'bodyLocale',
        value: {frCA: descriptionBodyLocale?.frCA, enCA: e.target.value},
      });
    };

  const onTypeChange = (type: any) => {
    updateProductOutageSideSheetData({ fieldName: 'outageType', value: type });
  };
  const onLearnMoreChange = (key: any = "enUS") => {

    const targetName = (key.target.name).includes("enUS") ? "enUS" : ((key.target.name).includes("enCA") ? "enCA" : "frCA");

    const inputEleVal = key.target.value;

    if (targetName === "enUS") {
      updateProductOutageSideSheetData({
        fieldName: 'linkToLearnMore',
        value: inputEleVal
      });
    } else {

      updateProductOutageSideSheetData({
        fieldName: 'linkToLearnMoreLocale',
        value: { enCA: (targetName === "enCA") ? inputEleVal : linkToLearnMoreLocale?.enCA, frCA: (targetName === "frCA") ? inputEleVal : linkToLearnMoreLocale?.frCA }
      });
    }
  };

  const onStatusChange = (e: any) => {
    setStatus(e);
    if (e === 'open'){
      updateProductOutageSideSheetData({ fieldName: 'endDate', value: null });
      updateProductOutageSideSheetData({ fieldName: 'endTime', value: '' });
    }
  };

  const closeSideSheet = () => {
    setWorkflowSideSheetCollapse(true);
    setApplicationSideSheetCollapse(true);
    setProductOutageSideSheetCollapse(true);
    resetOutageNotifcationSideSheetState();
  };

  const handleSave = () => {
    if (!handleValidation()) return;
    createMutation.mutate(createOutageModel(sideSheetData, userInfo));
  };

  const handleUpdate = () => {
    if (!handleValidation()) return;
      const model = [];
      model.push({messageId:sideSheetData.messageId});
      model.push(updateOutageModel(sideSheetData, userInfo));
      updateMutation.mutate(model);
  };

  const handleCancel = () => {
    closeSideSheet();
  };

  const handleTranslate = (lang: string) => {
    translateMutation.mutate(translationModel(sideSheetData, lang), {
      onSuccess: (translated) => {
        if (translated) {
          updateProductOutageSideSheetData({
            fieldName: 'titleLocale',
            value: {
              ...sideSheetData.titleLocale,
              [lang]: translated.title,
            },
          });

          updateProductOutageSideSheetData({
            fieldName: 'subjectLocale',
            value: {
              ...sideSheetData.subjectLocale,
              [lang]: translated.subject,
            },
          });

          updateProductOutageSideSheetData({
            fieldName: 'bodyLocale',
            value: {
              ...sideSheetData.bodyLocale,
              [lang]: translated.body,
            },
          });
        }
        setProductOutageShowToastState(t('productAlerts.toastTranslateSuccess'), 'Success');
      },
      onError: () => {
        setProductOutageShowToastState(t('productAlerts.toastTranslateError'), 'Error');
      },
    });
  };

  const hasContent = (html: string) => !!html?.replace(/<[^>]*>/g, '').trim();

  const handleValidation = () => {
    if (!sideSheetData.title) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidTitle'), 'Error');
      return false;
    }
    if (!sideSheetData.subject) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidDescription'), 'Error');
      return false;
    }
    if (!sideSheetData.body) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidDetailedDesc'), 'Error');
      return false;
    }

    const timeRegex = /^(0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if (sideSheetData.outageType === 'Unplanned') {
      if (!sideSheetData.caseId) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidIncidentNumber'), 'Error');
        return false;
      }

      if (!sideSheetData.createdDate) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidCreatedDate'), 'Error');
        return false;
      }

      if (
        !sideSheetData.createdTime ||
        !timeRegex.test(sideSheetData.createdTime)
      ) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidCreatedTime'), 'Error');
        return false;
      }

      if (status === 'close'){
        if (!sideSheetData.endDate) {
          setIsValidationState(true);
          setProductOutageShowToastState(t('productAlerts.toastInvalidEndDate'), 'Error');
          return false;
        }
  
        if (!sideSheetData.endTime || !timeRegex.test(sideSheetData.endTime)) {
          setIsValidationState(true);
          setProductOutageShowToastState(t('productAlerts.toastInvalidEndTime'), 'Error');
          return false;
        }
      }

    }

    if (sideSheetData.outageType === 'Planned') {
      if (!sideSheetData.startDate) {
        setIsValidationState(true);
        setShowStartDateValidation(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidStartDate'), 'Error');
        return false;
      }

      if (
        !sideSheetData.startTime ||
        !timeRegex.test(sideSheetData.startTime)
      ) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidStartTime'), 'Error');
        return false;
      }

      if (!sideSheetData.endDate) {
        setIsValidationState(true);
        setShowEndDateValidation(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidEndDate'), 'Error');
        return false;
      }

      if (!sideSheetData.endTime || !timeRegex.test(sideSheetData.endTime)) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastInvalidEndTime'), 'Error');
        return false;
      }

      const startDateV = moment(sideSheetData.startDate).set({
        hour: Number(sideSheetData.startTime.split(":")[0]),
        minute: Number(sideSheetData.startTime.split(":")[1]),
        second: 0,
        millisecond: 0
      });

      const endDateV = moment(sideSheetData.endDate).set({
        hour: Number(sideSheetData.endTime.split(":")[0]),
        minute: Number(sideSheetData.endTime.split(":")[1]),
        second: 0,
        millisecond: 0
      });

      if (!sideSheetData.messageId) {
        if (moment(new Date()).isAfter(startDateV)) {
          setIsValidationState(true);
          setProductOutageShowToastState(t('productAlerts.toastStartDateFuture'), 'Error');
          return false;
        }
      }

      if (moment(startDateV).isAfter(moment(endDateV))) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastEndDateAfterStart'), 'Error');
        return false;
      }

      const now = moment();
      if (moment(endDateV).isBefore(now)) {
        setIsValidationState(true);
        setProductOutageShowToastState(t('productAlerts.toastEndTimeFuture'), 'Error');
        return false;
      }
    }

    const isValid =
      sideSheetData?.targetEnterprises
        ?.split(',')
        .map((enterprise) => enterprise.trim())
        .every(
          (enterprise) => /^E\d{6}$/.test(enterprise) || enterprise === ''
        ) ?? true;
    const isCNumberValid =
      sideSheetData?.targetCNumbers
        ?.split(',')
        .map((cnumber) => cnumber.trim())
        .every(
          (cnumber) => /^C\d{6}$/.test(cnumber) || cnumber === ''
        ) ?? true;
    const isStoreValid =
        sideSheetData?.targetStores
          ?.split(',')
          .map((store) => store.trim())
          .every(
            (store) => /^S\d{9}$/.test(store) || store === ''
          ) ?? true;

    if (sideSheetData?.targetEnterprises && !isValid) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidEnterprise'), 'Error');
      return false;
    }
    if (sideSheetData?.targetCNumbers && !isCNumberValid) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidCNumber'), 'Error');
      return false;
    }
    if (sideSheetData?.targetStores && !isStoreValid) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidStore'), 'Error');
      return false;
    }

    if (
      sideSheetData?.linkToLearnMore &&
      !validateURL(sideSheetData?.linkToLearnMore)
    ) {
      setIsValidationState(true);
      setProductOutageShowToastState(t('productAlerts.toastInvalidLearnMore'), 'Error');
      return false;
    }

    return true;
  };

  const [activeItemIndex, setActiveItemIndex] = React.useState(0);
  
    let tabs: TabItem[] = [];
  
    tabs.push({
      id: 'tab-1',
      panelId: 'panel-1',
      renderPanel: (props: any) => (
        <StyledComponents.StyledTabPanel {...props}>
          <OutageCustomMultiTargetEditor readOnlyMode={archiveSwitch} />
        </StyledComponents.StyledTabPanel>
      ),
      renderTab: (props: any) => (
        <StyledComponents.StyledTab
          label={t('productAlerts.enterTargets')}
          {...props}
        />
      ),
    });
  
    tabs.push({
      id: 'tab-2',
      panelId: 'panel-2',
      renderPanel: (props: any) => (
        <StyledComponents.StyledTabPanel {...props}>
          <OutageBrowseOrDragBulkUpload />
        </StyledComponents.StyledTabPanel>
      ),
      renderTab: (props: any) => (
        <StyledComponents.StyledTab
          label={t('productAlerts.bulkUploadTargets')}
          {...props}
        />
      ),
    });

  return (
    <div style={{ padding: '10px' }}>
      <>
        <Checkbox
          style={{ width: '245px', paddingRight: "0.5rem" }}
          checked={showCanadaEnglishTranslation}
          dataTestId="show-canada-english-checkbox"
          id="notificationRelCa"
          label={t('productAlerts.showCanadaEnglish')}
          labelPosition="after"
          name="canadaEnglishShowRel"
          onChange={() => setShowCanadaEnglishTranslation(!showCanadaEnglishTranslation)}
          size="standard"
        />
        {
          showCanadaEnglishTranslation && sideSheetData.title && sideSheetData.subject && hasContent(sideSheetData.body) && (
            <PrimaryButton
              dataTestId="ca-translate-button"
              size={BUTTON_SIZES.SMALL}
              iconColor="primary"
              onClick={() => handleTranslate("enCA")}
              text={t('productAlerts.translate')}
              isDisabled={archiveSwitch || createMutation.isLoading}
            />
          )}
      </>
      <>
        <Checkbox
          style={{ width: '245px', paddingRight: "0.5rem" }}
          checked={showFrenchTranslation}
          dataTestId="show-french-checkbox"
          id="notificationRelFr"
          label={t('productAlerts.showCanadaFrench')}
          labelPosition="after"
          name="frenchShowRel"
          onChange={() => setShowFrenchTranslation(!showFrenchTranslation)}
          size="standard"
        />
        {
          showFrenchTranslation && sideSheetData.title && sideSheetData.subject && hasContent(sideSheetData.body) && (
            <PrimaryButton
              dataTestId="ca-translate-button"
              size={BUTTON_SIZES.SMALL}
              iconColor="primary"
              onClick={() => handleTranslate("frCA")}
              text={t('productAlerts.translate')}
              isDisabled={archiveSwitch || createMutation.isLoading}
            />
          )}
      </>
      <StyledComponents.StyledInput
        dataTestId={`title-input`}
        errorMessage={t('productAlerts.fieldErrorTitle')}
        id={`title-name-input-enUS`}
        inputDivider="left"
        label={t('productAlerts.titleLabel')}
        name={'title-enUS'}
        onChange={(e: any) => onTitleChange(e)}
        placeholder={t('productAlerts.titlePlaceholder')}
        value={get(sideSheetData, 'title', '')}
        hasCharacterCount={true}
        maxLength={100}
        isRequired={true}
        isDisabled={archiveSwitch}
      />
      <StyledComponents.StyledInput
        dataTestId={`short-desc-input`}
        errorMessage={t('productAlerts.fieldErrorDescription')}
        id={`short-desc-name-input-enUS`}
        inputDivider="left"
        label={t('productAlerts.shortDescLabel')}
        name="subject-enUS"
        placeholder={t('productAlerts.shortDescPlaceholder')}
        onChange={(e: any) => onShortDescChange(e)}
        value={get(sideSheetData, 'subject', '')}
        maxLength={150}
        hasCharacterCount={true}
        isRequired={true}
        isDisabled={archiveSwitch}
      />
      <div style={{ marginTop: '10px'}}>
        <StyledComponents.StyledCustomEditorLabel>{t('productAlerts.detailedDescription')}</StyledComponents.StyledCustomEditorLabel>
          <CustomEditor 
            value={get(sideSheetData, 'body', '')} 
            onChange={onLongDescChangeenUS} readOnlyMode={archiveSwitch}>
          </CustomEditor>
          <StyledComponents.StyledLongDescCount>
            <StyledComponents.StyledCountLabel>
              {get(sideSheetData, 'body', '').length}/4750
            </StyledComponents.StyledCountLabel>
          </StyledComponents.StyledLongDescCount>
      </div>
      {showCanadaEnglishTranslation &&
        <StyledComponents.StyledCustomEditorLabel>{t('productAlerts.canadaEnglish')}</StyledComponents.StyledCustomEditorLabel>
      }
      {showCanadaEnglishTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`title-input-enca`}
          errorMessage={t('productAlerts.fieldErrorTitle')}
          id={`title-name-input-enCA`}
          inputDivider="left"
          label={t('productAlerts.canadaEnglishTitle')}
          name={'title-enCA'}
          onChange={(e: any) => onTitleChange(e)}
          placeholder={t('productAlerts.canadaEnglishTitlePlaceholder')}
          value={get(sideSheetData, 'titleLocale.enCA', '')}
          hasCharacterCount={true}
          maxLength={100}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      {showCanadaEnglishTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`short-desc-input`}
          errorMessage={t('productAlerts.fieldErrorDescription')}
          id={`short-desc-name-input-enCA`}
          inputDivider="left"
          label={t('productAlerts.canadaEnglishShortDesc')}
          name="subject-enCA"
          placeholder={t('productAlerts.canadaEnglishShortDescPlaceholder')}
          onChange={(e: any) => onShortDescChange(e)}
          value={get(sideSheetData, 'subjectLocale.enCA', '')}
          hasCharacterCount={true}
          maxLength={150}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      {showCanadaEnglishTranslation && <>
        <div style={{ marginTop: '10px' }}>
          <StyledComponents.StyledCustomEditorLabel>{t('productAlerts.canadaEnglishDetailedDesc')}</StyledComponents.StyledCustomEditorLabel>
          <CustomEditor
            value={get(sideSheetData, 'bodyLocale.enCA', '')}
            onChange={onLongDescChangeenCA} readOnlyMode={archiveSwitch}>
          </CustomEditor>
          <StyledComponents.StyledLongDescCount>
            <StyledComponents.StyledCountLabel>
              {get(sideSheetData, 'bodyLocale.enCA', '').length}/4750
            </StyledComponents.StyledCountLabel>
          </StyledComponents.StyledLongDescCount>
        </div>
        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          <StyledComponents.StyledTextAreaWithCustomHeight
            customHeight="60px"
            dataTestId={`learn-more-input-enCA`}
            errorMessage="Error message"
            id={`learn-more-name-input-enCA`}
            inputDivider="left"
            label={t('productAlerts.learnMoreEnCA')}
            name="learnMore-enCA"
            onChange={onLearnMoreChange}
            placeholder={`Eg. https://connectcdk.com/`}
            value={get(sideSheetData, 'linkToLearnMoreLocale.enCA', '')}
            maxLength={200}
            isDisabled={archiveSwitch}
          />
        </div></>}
      {showFrenchTranslation &&
        <StyledComponents.StyledCustomEditorLabel>{t('productAlerts.canadaFrench')}</StyledComponents.StyledCustomEditorLabel>
      }
      {showFrenchTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`title-input-frca`}
          errorMessage={t('productAlerts.fieldErrorTitle')}
          id={`title-name-input-frCA`}
          inputDivider="left"
          label={t('productAlerts.frenchTitle')}
          name={'title-frCA'}
          onChange={(e: any) => onTitleChange(e)}
          placeholder={t('productAlerts.frenchTitlePlaceholder')}
          value={get(sideSheetData, 'titleLocale.frCA', '')}
          hasCharacterCount={true}
          maxLength={100}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      {showFrenchTranslation &&
        <StyledComponents.StyledInput
          dataTestId={`short-desc-input`}
          errorMessage={t('productAlerts.fieldErrorDescription')}
          id={`short-desc-name-input-frCA`}
          inputDivider="left"
          label={t('productAlerts.frenchShortDesc')}
          name="subject-frCA"
          placeholder={t('productAlerts.frenchShortDescPlaceholder')}
          onChange={(e: any) => onShortDescChange(e)}
          value={get(sideSheetData, 'subjectLocale.frCA', '')}
          hasCharacterCount={true}
          maxLength={150}
          isRequired={false}
          isDisabled={archiveSwitch}
        />}
      {showFrenchTranslation && <>
        <div style={{ marginTop: '10px' }}>
          <StyledComponents.StyledCustomEditorLabel>{t('productAlerts.frenchDetailedDesc')}</StyledComponents.StyledCustomEditorLabel>
          <CustomEditor
            value={get(sideSheetData, 'bodyLocale.frCA', '')}
            onChange={onLongDescChangefrCA} readOnlyMode={archiveSwitch}>
          </CustomEditor>
          <StyledComponents.StyledLongDescCount>
            <StyledComponents.StyledCountLabel>
              {get(sideSheetData, 'bodyLocale.frCA', '').length}/4750
            </StyledComponents.StyledCountLabel>
          </StyledComponents.StyledLongDescCount>
        </div>
        <div style={{ marginTop: '10px', marginBottom: '10px' }}>
          <StyledComponents.StyledTextAreaWithCustomHeight
            customHeight="60px"
            dataTestId={`learn-more-input-frCA`}
            errorMessage="Error message"
            id={`learn-more-name-input-fr`}
            inputDivider="left"
            label={t('productAlerts.learnMoreFrCA')}
            name="learnMore-frCA"
            onChange={onLearnMoreChange}
            placeholder={`Eg. https://connectcdk.com/`}
            value={get(sideSheetData, 'linkToLearnMoreLocale.frCA', '')}
            maxLength={200}
            isDisabled={archiveSwitch}
          />
        </div></>}
      
      <StyledComponents.StyledChoiceChips
        style={{ marginLeft: '0px' }}
        dataTestId={`choice-chips`}
        onClick={onTypeChange}
        id={`type-name-input`}
        name="outageType"
        options={[
          { label: t('productAlerts.unplanned'), value: 'Unplanned' },
          { label: t('productAlerts.planned'), value: 'Planned' },
        ]}
        value={get(sideSheetData, 'outageType')}
        isDisabled={sideSheetData.messageId ? true : false}
      />
      {get(sideSheetData, 'outageType') === 'Unplanned' && (
        <>
        <StyledComponents.StyledInput
          dataTestId={`caseid-input`}
          errorMessage={t('productAlerts.fieldErrorIncidentNo')}
          id={`caseid-name-input`}
          inputDivider="left"
          label={t('productAlerts.incidentNo')}
          name="caseId"
          onChange={onCaseIdChange}
          placeholder={t('productAlerts.incidentNoPlaceholder')}
          value={get(sideSheetData, 'caseId', '')}
          isRequired={true}
          isDisabled={sideSheetData.messageId ? true : false}
        />
      <div style={{ marginTop: '10px' }}>
          {
            sideSheetData.messageId &&
                      <StyledComponents.StyledSelectChip
                        defaultSelectedValue={status}
                        defaultLabel="Select"
                        style={{ zIndex: '1000' }}
                        onSelect={onStatusChange}
                        options={[
                          { id: 'open', label: t('productAlerts.open'), value: 'open' },
                          { id: 'closed', label: t('productAlerts.close'), value: 'close' },
                        ]}
                        prefix="Status :"
                        isDisabled={(sideSheetData.messageId && !archiveSwitch) ? false : true}
                      />
          }

          {
            (status === 'close') && (
            <div
              style={{
                marginTop: '10px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
            <div style={{ width: '180px',marginTop: '10px' }}>
              <StyledWrapperDatePicker dayPickerLeft="0px" maxWidth="180px">
              <DatePicker
                dataTestId="up-end-date-picker"
                date={get(sideSheetData, 'endDate', null)}
                dateFormat="MM/DD/YYYY"
                dateInputProps={{
                  enableCustomValidation: false,
                  errorMessage: 'Error message',
                  hasError: false,
                  isReadOnly: false,
                  isRequired: false,
                  isDisabled:archiveSwitch,
                  size: 'standard',
                }}
                id="up-end-date-picker"
                label={t('productAlerts.endDate')}
                maximumYear={2100}
                minimumYear={1900}
                name="up-end-date-picker"
                numberOfMonths={1}
                onDateChange={onEndDateChange}
                shortcutChipsPosition="none"
              />
              </StyledWrapperDatePicker>
            </div>
            <div style={{ width: '180px' }}>
              <TimeField
                handleChange={onEndTimeChange}
                value={get(sideSheetData, 'endTime', '')}
                name={'endTime'}
                label={t('productAlerts.endTime')}
                isDisabled={archiveSwitch}
                isRequired={true}
              />
            </div>
          </div>
            )
          }
          </div>
          </>
      )}
      <MultiSelectDropdownMenu
        options={applicationOptions || []}
        name="targetApplications"
        onSelect={onApplicationSelect}
        value={get(sideSheetData, 'targetApplications', '')}
        label={t('productAlerts.targetApplications')}
        placeholder={t('productAlerts.selectApplications')}
        isDisabled={archiveSwitch}
      ></MultiSelectDropdownMenu>
      <MultiSelectDropdownMenu
        options={workflowOptions || []}
        name="targetWorkflows"
        onSelect={onWorkflowSelect}
        value={get(sideSheetData, 'targetWorkflows', '')}
        label={t('productAlerts.targetWorkflows')}
        placeholder={t('productAlerts.selectWorkflows')}
        isDisabled={archiveSwitch}
      ></MultiSelectDropdownMenu>
     <StyledComponents.StyledTargetSelectorContainer>
           <StyledComponents.StyledTabs
             activeItemIndex={activeItemIndex}
             alignment="left"
             items={tabs}
             onActiveItemChange={setActiveItemIndex}
             tabsLabel=""
           />
      </StyledComponents.StyledTargetSelectorContainer>
      {get(sideSheetData, 'outageType') === 'Unplanned' && (
        <div
          style={{
            marginTop: '10px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ width: '170px', marginTop: '10px' }}>
            <StyledWrapperDatePicker dayPickerLeft="0px" maxWidth="180px">
              <DatePicker
                dataTestId="create-date-picker"
                date={get(sideSheetData, 'createdDate', null)}
                dateFormat="MM/DD/YYYY"
                dateInputProps={{
                  enableCustomValidation: false,
                  errorMessage: t('productAlerts.fieldErrorCreatedDate'),
                  hasError: false,
                  isReadOnly: false,
                  isRequired: true,
                  isDisabled: archiveSwitch,
                  size: 'standard',
                  onError: () => {},
                }}
                allowDaysInPast={true}
                id="create-date-picker"
                label={t('productAlerts.createdDate')}
                maximumYear={2100}
                minimumYear={1900}
                name="create-date-picker"
                numberOfMonths={1}
                onDateChange={onCreatedDateChange}
                shortcutChipsPosition="none"
              />
            </StyledWrapperDatePicker>
          </div>
          <div style={{ width: '180px' }}>
            <TimeField
              handleChange={onCreatedTimeChange}
              value={get(sideSheetData, 'createdTime', '')}
              name={'createdTime'}
              label={t('productAlerts.createdTime')}
              isDisabled={archiveSwitch}
              isRequired={true}
            />
          </div>
        </div>
      )}
      {get(sideSheetData, 'outageType') === 'Planned' && (
        <>
          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '180px' }}>
              <StyledWrapperDatePicker dayPickerLeft="0px" maxWidth="180px">
                <DatePicker
                  dataTestId="start-date-picker"
                  date={get(sideSheetData, 'startDate', null)}
                  dateFormat="MM/DD/YYYY"
                  dateInputProps={{
                    enableCustomValidation: true,
                    errorMessage: t('productAlerts.fieldErrorStartDate'),
                    hasError: showStartDateValidation,
                    isDisabled:archiveSwitch,
                    isReadOnly: false,
                    isRequired: true,
                    size: 'standard',
                    onError: () => {},
                  }}
                  id="start-date-picker"
                  label={t('productAlerts.startDate')}
                  maximumYear={2100}
                  minimumYear={1900}
                  name="start-date-picker"
                  numberOfMonths={1}
                  onDateChange={onStartDateChange}
                  shortcutChipsPosition="none"
                />
              </StyledWrapperDatePicker>
            </div>

            <div style={{ width: '180px' }}>
              <StyledWrapperDatePicker dayPickerLeft="-132px" maxWidth="180px">
                <DatePicker
                  className="endDatePicker"
                  dataTestId="end-date-picker"
                  date={get(sideSheetData, 'endDate', null)}
                  dateFormat="MM/DD/YYYY"
                  dateInputProps={{
                    enableCustomValidation: true,
                    errorMessage: t('productAlerts.fieldErrorEndDate'),
                    hasError: showEndDateValidation,
                    isDisabled:archiveSwitch,
                    isReadOnly: false,
                    isRequired: true,
                    size: 'standard',
                    onError: () => {},
                  }}
                  id="end-date-picker"
                  label={t('productAlerts.endDate')}
                  maximumYear={2100}
                  minimumYear={1900}
                  name="end-date-picker"
                  numberOfMonths={1}
                  onDateChange={onEndDateChange}
                  shortcutChipsPosition="none"
                />
              </StyledWrapperDatePicker>
            </div>
          </div>

          <div
            style={{
              marginTop: '10px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <div style={{ width: '180px' }}>
              <TimeField
                icon={<IconSchedule />}
                handleChange={onStartTimeChange}
                value={get(sideSheetData, 'startTime', '')}
                name={'startTime'}
                label={t('productAlerts.startTime')}
                isDisabled={archiveSwitch}
                isRequired={true}
              />
            </div>
            <div style={{ width: '180px' }}>
              <TimeField
                handleChange={onEndTimeChange}
                value={get(sideSheetData, 'endTime', '')}
                name={'endTime'}
                label={t('productAlerts.endTime')}
                isDisabled={archiveSwitch}
                isRequired={true}
              />
            </div>
          </div>
        </>
      )}
      <div style={{ marginTop: '10px' }}>
        <StyledComponents.StyledTextAreaWithCustomHeight
          customHeight="20px"
          dataTestId={`learn-more-input-enUS`}
          errorMessage="Error message"
          id={`learn-more-name-input-enUS`}
          inputDivider="left"
          label={t('productAlerts.learnMore')}
          name="learnMore-enUS"
          onChange={onLearnMoreChange}
          placeholder={`Eg. https://connectcdk.com/`}
          value={get(sideSheetData, 'linkToLearnMore', '')}
          maxLength={200}
          isDisabled={archiveSwitch}
        />
      </div>
      <ActionButtonContainer
        position="sticky"
        zIndex="999"
        positionProps={{ bottom: '0px' }}
        background={
          darkMode
            ? 'linear-gradient(black, transparent)'
            : 'linear-gradient(white, transparent)'
        }
      >
        <div>
          <StyledComponents.StyledTextButton
            dataTestId="text-button"
            iconColor="primary"
            onClick={handleCancel}
            text={t('productAlerts.cancel')}
          />

          {outagePermission?.hasProductAlertUpdatePermissions &&
            sideSheetData.messageId &&  !archiveSwitch && (
              <PrimaryButton
                dataTestId="save-side-sheet-button"
                iconColor="primary"
                onClick={handleUpdate}
                text={t('productAlerts.update')}
                isDisabled={updateMutation.isLoading}
                
              />
            )}

          {!sideSheetData.messageId && (
            <PrimaryButton
              dataTestId="save-side-sheet-button"
              iconColor="primary"
              onClick={handleSave}
              text={t('productAlerts.save')}
              isDisabled={createMutation.isLoading}
            />
          )}
        </div>
      </ActionButtonContainer>
    </div>
  );
};
